import { SelectTypeTeacher } from './modelsTeacher'
import { makeAutoObservable } from 'mobx'

interface ReportTypeTeacher {
	IsDelete: boolean
	date_insert: string
	date_update: Date | null
	date_viewed: Date | null
	groups: string
	id_faculty: number
	id_group: number
	id_oblast: number | null
	id_okno_document: number
	id_okno_zakaz: Number
	id_protocols: number
	id_raion: number | null
	id_republics: number | null
	id_student: number
	okno_document: string
	t_fio: string
	status: boolean
	EDS: boolean
	years: string
	ispolnitel: string
	status_new: boolean
}

class ReportTeacher {
	reportTypes: SelectTypeTeacher[] = []
	reportExpected: ReportTypeTeacher[] = []
	currentType: number = 0

	constructor() {
		makeAutoObservable(this)
	}

	newReportTypesTeacher(param: SelectTypeTeacher[]) {
		this.reportTypes = param
	}

	newReportTeacher(param: ReportTypeTeacher[]) {
		this.reportExpected = param
	}

	newTypeTeacher(param: number) {
		this.currentType = param
	}
}

export const reportTeacher = new ReportTeacher()
